import { combineReducers } from "redux";
import loadingCounter from "./loadingCounter";
import categoryTree from "./categoryTree";
import authorization from "./authorization";
import returnUrl from "./returnUrl";
import opportunity from "./opportunity";
import quote from "./quote";
import customer from "./customer";
import product from "./product";
import derivedCustomerGroup from "./derivedCustomerGroup";

export default combineReducers({
  authorization,
  categoryTree,
  customer,
  derivedCustomerGroup,
  loadingCounter,
  opportunity,
  product,
  quote,
  returnUrl
});
